import { CollectedPreviewItem, Deck, DeckCard } from "@apiserver-rest/ponder-data-client-base";
import { FilteredPreviewItems } from "./filtered-preview-items";
import { EventBroker } from "@ponder-core/events/eventBroker";
import { FilteredPreviewItem } from "./filtered-preview-item";
import { PreviewItemFilters } from "./preview-item-filters";

/**
 * Extension of {@link FilteredPreviewItems} to use with decks.
 */
export class FilteredDeckPreviewPreviewItems extends FilteredPreviewItems {
    private cardMap!: Map<string, FilteredPreviewItem>;

    public constructor(private deck: Deck, events: EventBroker) {
        var deckPreviewItems: CollectedPreviewItem[] = [];

        deck.layers?.forEach(l => {
            l.cards?.forEach(c => {
                deckPreviewItems.push(c.card);
            });
        });

        super(deckPreviewItems, events);

        this.rebuildCardMap();
    }

    public override populate(filters?: PreviewItemFilters | undefined): void {
        super.populate(filters);
        this.rebuildCardMap();
    }

    public rebuildCardMap(): void {
        this.cardMap = new Map<string, FilteredPreviewItem>();

        this.items.forEach(i => {
            this.cardMap.set(i.previewItem.item.id!, i);
        });
    }

    public isCardVisible(deckCard: DeckCard): boolean {
        var filteredItem = this.cardMap.get(deckCard.card.item.id!);
        return (filteredItem?.isVisible ? true : false);
    }
}